module.exports = __webpack_public_path__ + "static/img/Mitch_Duncan_mobile.fcf7cd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mitch_Duncan_mobile.jpg
// module id = 0t38
// module chunks = 0